import { styled } from "styled-components";

import { MarkdownArea } from "common/components";
import { useTranslate } from "common/utilities/useTranslate";
import { KnowledgeButtons } from "domains/publication/components/KnowledgeButtons";
import { getKnowledgeType } from "entities/knowledge/reducers";
import type { Knowledge } from "entities/knowledge/types";

const StyledTextContent = styled.div`
  padding-top: 10px;
`;

const StyledDescriptionContainer = styled.div`
  padding-top: 10px;
  width: 100%;
  border-top: ${({ theme }) => theme.borders.normal};
`;

const StyledDescription = styled.div`
  margin: 0;
  line-height: 1.2rem;
`;

const StyledButtonRow = styled.div`
  margin-top: 10px;
`;

type PublicationCardBodyProps = { knowledge: Knowledge; link: string };

export const PublicationCardBody = ({ knowledge, link }: PublicationCardBodyProps) => {
  const translate = useTranslate();
  const { summary } = knowledge;

  return (
    <StyledTextContent>
      <StyledDescriptionContainer>
        <StyledDescription>
          <MarkdownArea>{summary ?? translate("app.discover.topic.summary.no_description")}</MarkdownArea>
        </StyledDescription>
      </StyledDescriptionContainer>
      {link && (
        <StyledButtonRow>
          <KnowledgeButtons
            variant="knowledge"
            id={knowledge.id}
            title={knowledge.title}
            knowledgeType={getKnowledgeType(knowledge.source)}
            link={knowledge.link}
            isBookmarked={!!knowledge.is_bookmarked}
            isPinned={!!knowledge.is_pinned}
            shareLink={link}
            fullwidth
          />
        </StyledButtonRow>
      )}
    </StyledTextContent>
  );
};
